import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import HomePage from "./Pages/Homepage";   // the one with #home, #about, etc.
import Workshops from "./Pages/Workshops";
import { StyledNavbar } from './Pages/styled';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { HashLink } from 'react-router-hash-link';
import Blog from './Pages/Blog';


function App() {
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = () => {
    setExpanded(!expanded); // collapse navbar after click
  };


  return (
    <Router>
      <div className='d-flex flex-column'>
        {/* Top navbar */}

        <StyledNavbar expand='md' expanded={expanded} onToggle={() => setExpanded(!expanded)}>
          <Container>
            <Navbar.Brand href='/#home'>
              <img height={60} src={'/images/signature.png'} alt="macrame" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls='navbar-nav' />
            <Navbar.Collapse id='navbar-nav' className='justify-content-end'>
              <Nav className='ml-auto'>
                {/* Scroll links (anchor tags) */}
                <Nav.Link as={HashLink} smooth to="/#home" onClick={handleNavClick}>Home</Nav.Link>
                <Nav.Link as={HashLink} smooth to="/#about" onClick={handleNavClick}>About</Nav.Link>
                <Nav.Link as={HashLink} smooth to="/#gallery" onClick={handleNavClick}>Gallery</Nav.Link>
                <Nav.Link as={HashLink} smooth to="/#contact" onClick={handleNavClick}>Contact</Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/workshops"
                  onClick={handleNavClick}
                >
                  Workshops
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/blog"
                  onClick={handleNavClick}
                >
                  Blog
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </StyledNavbar>

        {/* Page routes */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<Blog />} />

          <Route path="/workshops" element={<div className='flex-grow-1'>
            <Workshops />
          </div>
          } />
        </Routes>

        <footer>
          <div className="footer-links">
            <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/made_by_rosita/">Instagram</a> | <a href="mailto:hello@madebyrosita.com">Email</a>
          </div>
          <div>
            <p>
              I make websites too.
            </p>
            All rights reserved. Website by &#xA9;madebyrosita {new Date().getFullYear()}
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
